import { createStore } from 'vuex'

export default createStore({
  state: {
    createThumbnailBy: {
      url: true,
      img: false
    },
    thumbnailType: {
      p1: true,
      p2: false
    },
    mockup: {
      p1: '/assets/img/mockup_p1.png',
      p2: '/assets/img/mockup_p2.png'
    },
    url: 'https://jima.netlify.app',
    urlChangeFlag: true,
    file: {
      pc: null,
      sp: null
    },
    bgColor: '#E0E8FF',
    bgStyle: {
      backgroundColor: '#E0E8FF'
    },
    screenShot: {
      pc: null,
      sp: null
    },
    worksThumbnailBase64: null,
    modal: {
      showModal: false,
      loading: false,
      generated: false
    },
    errors: {
      axios: {
        isError: false,
        msg: 'すみません、うまくいきませんでした。「よくある質問 」の方法をお試しください🙇'
      },
      btn: false
    }
  },
  mutations: {
    handleTabMenu (state) {
      state.createThumbnailBy.url ? state.createThumbnailBy.url = false : state.createThumbnailBy.url = true
      state.createThumbnailBy.img ? state.createThumbnailBy.img = false : state.createThumbnailBy.img = true
    },
    selectThumbnailType (state) {
      state.thumbnailType.p1 ? state.thumbnailType.p1 = false : state.thumbnailType.p1 = true
      state.thumbnailType.p2 ? state.thumbnailType.p2 = false : state.thumbnailType.p2 = true
    },
    handleUrl (state, e) {
      state.url = e.target.value
    },
    handleUrlChangeFlag (state, bool) {
      state.urlChangeFlag = bool
    },
    handleBgColor (state, e) {
      state.bgColor = e.target.value
      state.bgStyle.backgroundColor = e.target.value
    },
    handleFilePc (state, e) {
      state.file.pc = e.target.files[0]
    },
    handleFileSp (state, e) {
      state.file.sp = e.target.files[0]
    },
    handleModalLoadingOpen (state) {
      state.modal.showModal = true
      state.modal.loading = true
    },
    handleModalTurnGenerated (state) {
      state.modal.loading = false
      state.modal.generated = true
    },
    handleModalCloseAll (state) {
      state.modal.showModal = false
      state.modal.generated = false
    },
    handleAxiosError (state, bool) {
      state.errors.axios.isError = bool
    },
    handleBtnError (state, bool) {
      state.errors.btn = bool
    }
  },
  actions: {
  },
  modules: {
  }
})
